<div class="container c-header">
  <!-- Header -->
  <div class="text-center d-flex justify-content-between align-items-center pt-2 pb-2">
    <h3 class="d-flex align-items-center" style="gap: 10px;">
      <img alt="Logo" style="height: 50px;margin-right: 5px" src="./assets/image/invivo_raw.png?v=123">
      <span style="line-height: 50px;font-size: 32px;color: #1e5ba3">{{appName}}</span>
    </h3>
    <p class="mb-0 text-bold p-title">
      {{partnerInfo.name.toUpperCase()}}
    </p>
    <div>
      <a (click)="showModalPassword()" class="text-decoration-underline">Đổi mật khẩu</a>
      |
      <a (click)="logout()" class="text-decoration-underline">Đăng xuất</a>
    </div>
  </div>
</div>
<nav>
  <div class="container">
    <div class="content-wrap clearfix">
      <ul class="nav-bar-con-item">
        <li><a href="javascript:void(0)">
          <span class="fa fa-home fa-fw"></span>
          Trang chủ</a></li>
        <li><a href="javascript:void(0)">Giới thiệu</a></li>
        <li><a routerLinkActive="active" routerLink="/doctor/result">Tra cứu kết quả</a></li>
        <li *ngIf="isShowMenuPrice"><a routerLinkActive="active" routerLink="/doctor/prices">Bảng giá dịch vụ</a></li>
        <li><a href="javascript:void(0)">Liên hệ</a></li>
      </ul>
    </div>
  </div>
</nav>
<dx-popup
  [title]="'Đổi mật khẩu'"
  [(visible)]="isShowChangePassword"
  class="form-popup"
  [width]="400"
  [height]="500"
>
  <dxi-toolbar-item toolbar="bottom" location="after">
    <div class="form-popup-buttons-container">
      <dx-button class="mr-2"
                 text="Hủy"
                 stylingMode="outlined"
                 type="normal"
                 (onClick)="closePopupChangePassword()"
      ></dx-button>
      <dx-button
        text="Cập nhật"
        stylingMode="contained"
        type="default"
        (onClick)="onChangePasswordClick()"
      ></dx-button>
    </div>
  </dxi-toolbar-item>

  <div class="popup-content">
    <div class="alert alert-info text-center mb-3">
      Vui lòng nhập mật khẩu hiện tại và mật khẩu mới để cập nhật.
    </div>
    <div class="alert alert-danger text-center mb-3" *ngIf="messageError">
      {{messageError}}
    </div>

    <div class="mb-3">
      <label>Mật khẩu cũ</label>
      <dx-text-box
        [(value)]="passwordChange.oldPassword"
        [mode]="'password'"
        placeholder="Nhập mật khẩu cũ"
      ></dx-text-box>
    </div>

    <div class="mb-3">
      <label>Mật khẩu mới</label>
      <dx-text-box
        [(value)]="passwordChange.password"
        [mode]="'password'"
        placeholder="Nhập mật khẩu mới"
      ></dx-text-box>
    </div>

    <div class="mb-3">
      <label>Nhập lại mật khẩu mới</label>
      <dx-text-box
        [(value)]="passwordChange.repeatPassword"
        [mode]="'password'"
        placeholder="Nhập lại mật khẩu mới"
      ></dx-text-box>
    </div>

    <div *ngIf="passwordChange.password && passwordChange.password !== passwordChange.repeatPassword"
         class="text-danger">
      Mật khẩu mới không khớp. Vui lòng kiểm tra lại.
    </div>
  </div>
</dx-popup>
<router-outlet></router-outlet>


